<template>
  <div class="data-auth">
    
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>审核授权</el-breadcrumb-item>
      <el-breadcrumb-item>观测数据直接授权</el-breadcrumb-item>
    </el-breadcrumb>

    <el-divider ></el-divider>

    <div class="container">
      <div class="container-item">
        <div class="dataitem">
          
          <el-form :inline="true" :model="searchParams" class="search-form">
            <el-form-item :label="$t('proposal.obs_id')">
              <el-autocomplete
                size="mini"
                placeholder=""
                style="width: 220px"
                v-model="searchParams.obs_id"
                :fetch-suggestions="querySearch"
                :trigger-on-focus="false"
                clearable>
              </el-autocomplete>
            </el-form-item> 
            <el-form-item :label="`${$t('proposal.condition.proposal')}:`">
              <el-autocomplete
                size="mini"
                placeholder=""
                style="width: 220px"
                v-model="searchParams.proposal"
                :fetch-suggestions="proquerySearch"
                :trigger-on-focus="false"
                clearable>
              </el-autocomplete>
            </el-form-item>    
            <el-form-item>
              <el-button size='mini'  @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-form>

          <el-table
            :data="datalist"
            style="width: 95%;"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              prop="id"
              label="ID"
              v-if="false">
            </el-table-column>
            <el-table-column
              fixed="left"
              prop="obs_id"
              label="观测号">        
            </el-table-column>
            <el-table-column
              prop="proposal"
              label="观测提案">
            </el-table-column>
            <el-table-column
              prop="schedule_id"
              label="计划号"
              v-if="false">
            </el-table-column>   
            <el-table-column
              prop="tstart"
              label="数据开始时间TT"
              v-if="false">
            </el-table-column>
            <el-table-column
              prop="tsop"
              label="数据结束时间TT"
              v-if="false">
            </el-table-column>
            <el-table-column
              prop="start_utc"
              label="数据开始时间UTC">
            </el-table-column>
            <el-table-column
              prop="stop_utc"
              label="数据结束时间UTC">
            </el-table-column>
            <el-table-column
              prop="duration"
              label="数据时长">
            </el-table-column>
            <el-table-column
              prop="target"
              label="目标">
            </el-table-column>
            <el-table-column
              prop="obs_mode"
              label="观测模式"
              width="55">
            </el-table-column>
            <el-table-column
              prop="data_mode"
              label="数据模式"
              width="55">
            </el-table-column>
            <el-table-column
              prop="observer"
              label="观测者">
            </el-table-column>
            <el-table-column
              prop="ptype"
              label="提案类型">
            </el-table-column>
            <el-table-column
              prop="status"
              label="数据状态"
              width="55">
            </el-table-column>
            <el-table-column
              prop="owner"
              label="权属">
            </el-table-column>
            <el-table-column
              fixed="right"
              prop="isopen"
              label="公开"
              width="55">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            :total="total"
            @size-change="sizeChange"
            @current-change="changePage">
          </el-pagination>
        </div>
      </div>

      <div class="container-item">
        <div>
          <el-form :inline="true" :model="usrsearchParams" class="search-form">
            <el-form-item  label="用户邮箱:">
              <el-input size="mini"  v-model="usrsearchParams.useremail"></el-input>
            </el-form-item>  
            <el-form-item>
              <el-button size='mini' @click="searchusr">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="usrlist"
            style="width: 100%"
            @selection-change="usrhandleSelectionChange">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              prop="id"
              label="ID"
              v-if="false">
            </el-table-column>
            <el-table-column
              prop="umtId"
              label="umtId"
              v-if="false">
            </el-table-column>
            <el-table-column
              prop="cstnetId"
              label="cstnetId"
              v-if="false">
            </el-table-column>
            <el-table-column
              width="70"
              prop="truename"
              label="姓名">
            </el-table-column>
            <el-table-column
              prop="useremail"
              label="用户邮件地址">
            </el-table-column>
            <el-table-column
              width="140"
              prop="userphone"
              label="用户电话">
            </el-table-column>
            <el-table-column
              prop="usercp"
              label="用户单位">
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page.sync="usrcurrentPage"
            :page-size.sync="usrpageSize"
            :total="usrtotal"
            @size-change="usrsizeChange"
            @current-change="usrchangePage">
          </el-pagination>
        </div>
        <div>  
          <el-form class="authbtn">
            <el-form-item >
              <el-button size="max" type="primary" @click="auth">授权</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'data-auth',
  data() {
    return {
      searchParams: {
        proposal: '',
      },
      usrsearchParams:{
        useremail:'',
      },
      datalist: [],
      usrlist:[],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      usrcurrentPage: 1,
      usrpageSize: 20,
      usrtotal: 0,
      restaurants:[],
      prorestaurants:[],
      multipleSelection:[],
      usrmultipleSelection:[],
      // checkedisstate:false,
    };
  },
  created() {
    this.getData();
    this.getobslistdata();
    this.getprolistdata();
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        usrcurrentPage: this.usrcurrentPage,
        usrpageSize: this.usrpageSize,
        proposal: this.searchParams.proposal,
        obs_id: this.searchParams.obs_id,
        useremail: this.usrsearchParams.useremail,
      }
      axios.post('/iapi/dmauthdata', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.usrtotal = res.data.data.usrtotal;
          this.datalist = res.data.data.list;
          this.usrlist = res.data.data.usrlist;
        }
      });
      // console.log("authstates",this.currentastates);
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    usrchangePage(page) {
      this.usrcurrentPage = page;
      this.getData();
    },
    usrsizeChange() {
      this.getData();
    },
    searchusr(){
      this.usrcurrentPage = 1;
      this.getData();
    },
    auth(){
      if(this.multipleSelection.length===0){
        alert('请选择数据!')
        return;
      }else if(this.usrmultipleSelection.length===0){
        alert('请选择用户!')
        return;
      }
      // console.log('data',this.multipleSelection);
      // console.log('usr',this.usrmultipleSelection);

      const params = {
        data:this.multipleSelection,
        usr:this.usrmultipleSelection,
      };
      axios.post('/iapi/DmBatchAuth', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('批量数据授权成功！');
        }else if(res.data.errcode === 1){
          this.$message('无可授权数据');
        }else if(res.data.errcode === 2){
          alert('登陆超时,请重新登陆!');
        }
      });
      // this.getData();
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
      // console.log('多选内容',this.multipleSelection);
    },
    usrhandleSelectionChange(val){
      this.usrmultipleSelection = val;
      // console.log('多选内容',this.multipleSelection);
    },
    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    proquerySearch(queryString, cb) {
      let prorestaurants = this.prorestaurants;
      let results = queryString ? prorestaurants.filter(this.procreateFilter(queryString)) : prorestaurants;
      cb(results);
    },
    procreateFilter(queryString) {
      return (prorestaurants) => {
        return (prorestaurants.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    getobslistdata(){
      axios.post('/iapi/getobslist').then((res) => {
        if (res.data.errcode === 0) {
          this.restaurants = res.data.data;
        }
      });
    },
    getprolistdata(){
      axios.post('/iapi/proposallist').then((res) => {
        if (res.data.errcode === 0) {
          this.prorestaurants = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.data-auth {
  padding: 24px 24px;
}
.el-pagination {
  text-align: center; 
}
.container {
  display: flex;
  width: 100%;
}
.container-item {
  flex: 1 1 auto;
}
.search-form {
  padding: 8px 0;
}
.admin-path {
  margin-bottom: 16px;
}
.el-divider--horizontal {
  margin: 8px 0;
}
.authbtn{
  margin: auto;
}
</style>
